import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createSelector } from "reselect"
import { getReportsStateObject } from "../../selectors"
import type { StateObject } from "../../../../redux/types"
import type { CustomersFeedbackReportItem } from "../../../../data/types"
import type { CustomerFeedbackPagesObject, CustomersFeedbackState } from "../../reducer"
import { getFilters } from "../../../../filters/selectors"
import type { QueryApiParameters } from "../../../../../utils/queryApi/queryApiRequest"
import type { CustomersFeedbackTableDataItem } from "./CustomersFeedbackTable"

export const getCustomersFeedbackState = (state: StateObject): CustomersFeedbackState =>
    getReportsStateObject(state).customersFeedback

export const getCustomersFeedbackPages = (state: StateObject): CustomerFeedbackPagesObject =>
    getCustomersFeedbackState(state).pages

export const getCustomersFeedbackCurrentPage = (state: StateObject): number =>
    getFilters(state, "customersFeedback").pagination.currentPage

export const getCustomersFeedbackByPageNumber = (
    state: StateObject,
    page: number
): Maybe<CustomersFeedbackReportItem[]> => getCustomersFeedbackPages(state)[page]

export const getCustomersFeedbackInCurrentPage: (state: StateObject) => CustomersFeedbackReportItem[] = createSelector(
    getCustomersFeedbackPages,
    getCustomersFeedbackCurrentPage,
    (pages: CustomerFeedbackPagesObject, current: number) => pages[current] || []
)

export const getDataForCustomersFeedbackReportTable = (state: StateObject): CustomersFeedbackTableDataItem[] =>
    getCustomersFeedbackInCurrentPage(state)
// Only for Download, later remove

export const getCustomersFeedbackQueryApiParamForDownload = (state: StateObject): QueryApiParameters => {
    const filters = getFilters(state, "customersFeedback")
    // Construct parameters
    const result = {
        ...(filters.search && filters.search.value.length > 0
            ? {
                  search: filters.search.value,
              }
            : null),
        ...(filters.sort && filters.sort.by
            ? {
                  sort: filters.sort.by.toLowerCase(),
              }
            : null),
        ...(filters.sort && filters.sort.direction
            ? {
                  sort_order: filters.sort.direction,
              }
            : null),
        ...(filters.feedbackType
            ? {
                  feedback: filters.feedbackType,
              }
            : null),
    }
    return result
}

export type CustomersFeedbackApiParameters = {
    count: number
    // number of orders per page
    offset: number
    search?: string
    sort?: string
    sort_order?: string // ASC or DESC
}

export const getCustomersFeedbackQueryApiParam = (state: StateObject): CustomersFeedbackApiParameters => {
    const filters = getFilters(state, "customersFeedback")
    const offset = (filters.pagination.currentPage - 1) * filters.pagination.pageLimit
    // Construct parameters
    const result = {
        count: filters.pagination.pageLimit,
        offset: offset,
        ...(filters.search && filters.search.value.length > 0
            ? {
                  search: filters.search.value,
              }
            : null),
        ...(filters.sort && filters.sort.by
            ? {
                  sort: filters.sort.by.toLowerCase(),
              }
            : null),
        ...(filters.sort && filters.sort.direction
            ? {
                  sort_order: filters.sort.direction,
              }
            : null),
    }
    return result
}
